// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class Statistics {
    public Type: any;
    public BeginProjectedBalance: any;
    public AccountOperationStatistic: any;

    constructor () {
        this.Type = null;
        this.BeginProjectedBalance = null;
        this.AccountOperationStatistic = null;
    }

    public FillByMessage (message): void {
        this.Type = message.Type;
        if (message.BeginProjectedBalance !== null) { this.BeginProjectedBalance = message.BeginProjectedBalance; }
    }
}
